// frontend/src/components/placements/PlacementsPage.jsx
import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import PlacementList from "./PlacementList";
import PlacementForm from "./PlacementForm";

const PlacementsPage = () => {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedPlacement, setSelectedPlacement] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreate = () => {
    setSelectedPlacement(null);
    setActiveTab("form");
  };

  const handleEdit = (placement) => {
    setSelectedPlacement(placement);
    setActiveTab("form");
  };

  const handleView = (placement) => {
    setSelectedPlacement(placement);
    setActiveTab("view");
  };

  const handleSave = () => {
    setSelectedPlacement(null);
    setActiveTab("list");
    setRefreshKey((prev) => prev + 1);
  };

  const handleCancel = () => {
    setSelectedPlacement(null);
    setActiveTab("list");
  };

  return (
    <div className="container-fluid px-2 px-md-4 mt-3 mt-md-4">
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mb-md-3 gap-2">
        <h4 className="mb-0 h5">
          <i className="bi bi-briefcase me-2"></i>
          Placements
        </h4>
      </div>

      {/* Info Card */}
      <div className="alert alert-info mb-2 mb-md-3 py-2 small">
        <i className="bi bi-info-circle me-2"></i>
        <strong>Job Placements:</strong> Track consumer job placements including 
        employer details, wages, hours, and employment status. Monitor placement 
        success and manage the full employment lifecycle.
      </div>

      {/* Navigation Tabs */}
      <ul className="nav nav-tabs flex-nowrap overflow-auto mb-2 mb-md-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              setSelectedPlacement(null);
              setActiveTab("list");
            }}
          >
            <i className="bi bi-list-ul me-2"></i>
            All Placements
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "form" ? "active" : ""}`}
            onClick={handleCreate}
          >
            <i className="bi bi-plus-circle me-2"></i>
            {selectedPlacement ? "Edit Placement" : "New Placement"}
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "list" && (
          <PlacementList
            key={refreshKey}
            onEdit={handleEdit}
            onCreate={handleCreate}
            onView={handleView}
          />
        )}

        {activeTab === "form" && (
          <PlacementForm
            placement={selectedPlacement}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        )}
      </div>
    </div>
  );
};

export default PlacementsPage;